import { render, staticRenderFns } from "./DesktopNavigationEntry.vue?vue&type=template&id=063b6d8f&scoped=true"
import script from "./DesktopNavigationEntry.vue?vue&type=script&lang=js"
export * from "./DesktopNavigationEntry.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavigationEntry.scss?vue&type=style&index=0&id=063b6d8f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b6d8f",
  null
  
)

export default component.exports